import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import {
  BLACK, BLACK_300, BLUE, GRAY1, GREEN,
} from 'constants/colors';
import { IntersemanalVisaoGeral } from 'types/Relatorios/Intersemanal';

// Cores fixas por série (Figma): PLD max/min em cinza (faixa de referência),
// PLD em preto, Ampere e Controle nas cores de marca — o mesmo mapeamento é
// usado pelas bolinhas de legenda da tabela (ver `SERIE_COR` em index.tsx).
// tema: dados-inicio — cor de série (o ThemedECharts e a bolinha da tabela adaptam no escuro)
export const SERIE_COR: Record<string, string> = {
  'PLD max': BLACK_300,
  'PLD min': GRAY1,
  PLD: BLACK,
  Ampere: BLUE,
  Controle: GREEN,
};

const PALETA_FALLBACK = [BLUE, GREEN, BLACK, GRAY1, BLACK_300];
// tema: dados-fim

interface Props { data: IntersemanalVisaoGeral; }

export default function VisaoGeralChart({ data }: Props) {
  const option = {
    legend: { data: data.series.map((s) => s.nome) },
    xAxis: { type: 'category', data: data.periodos },
    yAxis: { type: 'value', name: data.unidade },
    series: data.series.map((s, i) => ({
      name: s.nome,
      type: 'line',
      data: s.valores,
      color: SERIE_COR[s.nome] ?? PALETA_FALLBACK[i % PALETA_FALLBACK.length],
      ...(s.nome === 'PLD max' || s.nome === 'PLD min' ? { areaStyle: { opacity: 0.15 } } : {}),
    })),
    tooltip: { trigger: 'axis' },
    grid: { left: '10%', right: '5%', containLabel: true },
  };

  return <ReactECharts option={option} style={{ height: 320 }} />;
}
